import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SemesterModal = ({ isOpen, onClose, semester, yearId, onSave }) => {
    const [formData, setFormData] = useState({
        name: '',
        term_number: 1,
        start_date: '',
        end_date: '',
        status: 'upcoming'
    });

    useEffect(() => {
        if (semester) {
            setFormData({
                name: semester.name,
                term_number: semester.term_number,
                start_date: semester.start_date,
                end_date: semester.end_date,
                status: semester.status
            });
        } else {
            setFormData({
                name: '',
                term_number: 1,
                start_date: '',
                end_date: '',
                status: 'upcoming'
            });
        }
    }, [semester]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.start_date >= formData.end_date) {
            window.alert('End date must be after the start date.');
            return;
        }
        onSave(formData);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-background rounded-xl shadow-xl w-full max-w-md border animate-in zoom-in-95 duration-200">
                <div className="flex items-center justify-between p-6 border-b">
                    <h2 className="text-xl font-semibold">
                        {semester ? 'Edit Semester' : 'Add Semester'}
                    </h2>
                    <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
                        <Icon name="X" size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium">Semester Name</label>
                        <input
                            type="text"
                            required
                            placeholder="e.g., Semester 1"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            className="w-full h-10 px-3 rounded-md border bg-background focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                        />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium">Term Number (1-3)</label>
                        <select
                            value={formData.term_number}
                            onChange={(e) => setFormData({ ...formData, term_number: parseInt(e.target.value) })}
                            className="w-full h-10 px-3 rounded-md border bg-background focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                        >
                            <option value={1}>Term 1</option>
                            <option value={2}>Term 2</option>
                            <option value={3}>Term 3</option>
                        </select>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <label className="text-sm font-medium">Start Date</label>
                            <input
                                type="date"
                                required
                                value={formData.start_date}
                                onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                                className="w-full h-10 px-3 rounded-md border bg-background focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                            />
                        </div>
                        <div className="space-y-2">
                            <label className="text-sm font-medium">End Date</label>
                            <input
                                type="date"
                                required
                                value={formData.end_date}
                                onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                                className="w-full h-10 px-3 rounded-md border bg-background focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                            />
                        </div>
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium">Status</label>
                        <select
                            value={formData.status}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            className="w-full h-10 px-3 rounded-md border bg-background focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                        >
                            <option value="upcoming">Upcoming</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                        {formData.status === 'active' && (
                            <p className="text-xs text-yellow-600 bg-yellow-50 p-2 rounded border border-yellow-200">
                                Warning: Setting this to 'Active' will automatically close any currently active semester.
                            </p>
                        )}
                    </div>

                    <div className="flex justify-end gap-3 pt-4">
                        <Button type="button" variant="outline" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="submit">
                            {semester ? 'Save Changes' : 'Add Semester'}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SemesterModal;
